module.exports = __webpack_public_path__ + "img/logo.bce55f90.png";